<p-dialog [baseZIndex]="1000" [modal]="true" [(visible)]="displayModal" (onHide)="closeDialog()"
  [contentStyle]="{'overflow':'visible'}" class="password-dimenticata-dialog" header="{{'resetPassword' | translate}}">
  <div class="row" *ngIf="formPassword">
    <div class="col-12">
      <form *ngIf="!confirmSection">
        <form-row>
          <ng-template formRowTemplate="content">
            <form-input-text [control]="formPassword.controls['username']" [label]="'nomeUtente'|translate"
              [placeholder]="'stdPlaceholder'|translate" [errorMsg]="'inserireUsername_msg'|translate">
            </form-input-text>
          </ng-template>
        </form-row>

        <hr>

        <form-row>
          <ng-template formRowTemplate="content">
            <div class="buttonbar">
              <button type="button" class="btn btn-danger text-white mr-2" (click)="closeDialog()">
                {{'annulla' | translate}}
              </button>
              <button type="button" class="btn btn-primary text-white mr-2" (click)="confirmSection = !confirmSection"
                [disabled]="formPassword.invalid">
                {{'procedi' | translate}}
                <i class="fas fa-fw fa-arrow-right"></i>
              </button>
            </div>
          </ng-template>
        </form-row>
      </form>

      <form *ngIf="confirmSection">
        <form-row>
          <ng-template formRowTemplate="content">
            <p>
              {{'cliccandoSu'|translate}} <b>{{'reset'|translate}}</b> {{'generataNuovaPwd'|translate}} <br><br>
              {{'modificarlaAlPiuPresto_msg'|translate}}
            </p>
          </ng-template>
        </form-row>

        <hr>

        <form-row>
          <ng-template formRowTemplate="content">
            <div class="buttonbar">
              <button type="button" class="btn btn-danger text-white mr-2" (click)="closeDialog()">
                {{'annulla' | translate}}
              </button>
              <button type="button" class="btn btn-primary text-white mr-2" (click)="resetPassword()">
                <i class="fas fa-fw fa-check"></i>
                {{'reset' | translate}}
              </button>
            </div>
          </ng-template>
        </form-row>
      </form>
      <br>
    </div>
  </div>
</p-dialog>